<template>
    <div class="activity-item-comments__main" id="comments-box" >

        <!-- Form tu response a comment -->
        <form class="activity-item-comments__form" @submit.prevent="submit()" >

            <img :src="user.profile_thumbnail" alt="" v-rjs="2" />

            <input
                type="text"
                ref="comment"
                placeholder="Enter comment"
                v-model="responseForm.body"
            />
            <button type="submit" :class="{  'dis': !responseForm.body || responseForm.isSubmitted }" :disabled="responseForm.isSubmitted">
                Post
            </button>
        </form>

        <div class="activity-item-comments__comment" v-for="response in responses" :key="response.id" >

            <a :href="`/${response.user.username}`" class="comment-profile">
                <img :src="response.user.profile_thumbnail" alt="" v-rjs="2" />
            </a>

            <div class="comment-header">
                <h3>
                    <a :href="`/${response.user.username}`" class="person-hover-trigger" :data-user="response.user.username" >
                        {{ response.user.full_name }}
                        <Verified :user="response.user"></Verified>
                    </a>
                    {{ diffForHumans(response.created_at) }}
                </h3>
            </div>

            <div class="comment-body">
                <p class="main-comment" v-if="response.body.length > 150">
                    {{ response.body.substring(0, 150) }}
                    <button class="review-comment-expand">
                        More +
                    </button>
                </p>
                <p class="full-comment">
                    {{ response.body }}
                    <button
                        v-if="response.body.length > 150"
                        class="review-comment-shrink">
                        Less -
                    </button>
                </p>
            </div>

            <div class="comment-extra">
                <LoveCommentToggle :post="post" :comment="response" :user="user" />
            </div>

        </div>
    </div>
</template>
<script>

import Form from '@/classes/Form'
import Verified from '@/components/Verified'
import Helpers from '@/mixins/Helpers'
import LoveCommentToggle from "@/components/Comments/LoveToggle";

export default {

    mixins: [Helpers],

    components: {
        Verified,
        LoveCommentToggle
    },

    props: ['post', 'comment', 'user'],

    data() {
        return {
            responses: this.comment.responses,
            responseForm: new Form({
                parent_id: this.comment.id,
                post_id: this.post.id,
                body: '',
            })
        }
    },

    methods: {
        submit() {
            this.responseForm.post(`/${this.post.slug}/comments/${this.comment.id}/response`)
                .then(response => {
                    this.responseForm.parent_id = this.comment.id
                    this.responseForm.post_id = this.comment.post_id
                    this.responses = response.comment.responses
                    this.$emit('updated', response.comment)
                })
        },
    }
}
</script>
